export default __webpack_public_path__ + "static/media/Resume2.8fe6feaf.pdf";